import { render, staticRenderFns } from "./ZhiqiTong3.vue?vue&type=template&id=1a18d5a0&scoped=true"
import script from "./ZhiqiTong3.vue?vue&type=script&lang=js"
export * from "./ZhiqiTong3.vue?vue&type=script&lang=js"
import style0 from "./ZhiqiTong3.vue?vue&type=style&index=0&id=1a18d5a0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a18d5a0",
  null
  
)

export default component.exports